import api from "@/lib/api/axios";

// Types for trusted user API
export interface UpdateFingerprintRequest {
  invitation_code: string;
  fingerprint_hash: string;
}

export interface UpdateFingerprintResponse {
  success: boolean;
  message?: string;
}

export const trustedUserApi = {
  /**
   * Update fingerprint for a trusted user invitation
   *
   * @param data - Object containing invitation_code and fingerprint_hash
   */
  updateFingerprint: async (
    data: UpdateFingerprintRequest,
  ): Promise<UpdateFingerprintResponse> => {
    const response = await api.post<UpdateFingerprintResponse>(
      "/api/users/trusted-user/update-fingerprint/",
      data,
    );
    return response.data;
  },
};
